<template>
  <div
    v-in-viewport="emitInput"
    class="text-center my-6"
    :class="{'text-white': white}"
    v-if="!isLast && !$parent.entityLastPage[name]"
  >
    <div
      class="font-medium tracking-wide"
      :class="[showCount ? '' : ' mb-2']"
      v-if="showPage && $parent.entityResults[name]"
    >
      {{ $parent.entityResults[name].current_page }} /
      {{ $parent.entityResults[name].last_page }}
    </div>
    <div
      class="text-sm tracking-wide mb-3"
      :class="[white ? 'text-white' : 'text-gray-400']"
      v-if="showCount && $parent.entityResults[name]"
    >
      {{ $parent.entities[name].length }} {{ $t("general.of") }}
      {{ $parent.entityResults[name].total }}
    </div>
    <wd-button :white="white" :sending="$parent.entityLoading" @input="emitInput">{{
      buttonText || $t("general.show_more")
    }}</wd-button>
  </div>
</template>

<script>
export default {
  name: "LoadMoreSection",
  data() {
    return {
    };
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    showCount: {
      type: Boolean,
      default: false,
    },
    showPage: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: null,
    },
    white: {
      type: Boolean,
      default: false
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  methods: {
    emitInput() {
      this.$emit("input");
    },
  },
  computed: {
  },
  created() {
  },
};
</script>